import React from 'react';

import { Link } from '@gravity-ui/uikit';
import { routes } from 'client/lib/routes';
import { getCanViewAsAdmin } from 'client/utils';

export const NdaLink = () => {
    if (!getCanViewAsAdmin()) return null;

    return (
        <>
            <Link href={routes.documentation.nda} target="_blank">
                NDA
            </Link>
            <span>{` `}</span>
        </>
    );
};
